import type { OrdenPosDetalleResponse } from '../types/pos.types';

export const IGV_RATE = 0.18;

export function calcularLineaItem(
  cantidad: number,
  precioUnitario: number,
  descuento: number = 0
): { subTotal: number; igv: number; total: number } {
  const subTotal = (cantidad * precioUnitario) - descuento;
  const igv = subTotal * IGV_RATE;
  const total = subTotal + igv;
  return { subTotal, igv, total };
}

export function calcularTotalesOrden(items: OrdenPosDetalleResponse[]): {
  subTotal: number;
  totalIGV: number;
  totalDescuento: number;
  total: number;
} {
  return items.reduce(
    (acc, item) => ({
      subTotal: acc.subTotal + item.subTotal,
      totalIGV: acc.totalIGV + item.igv,
      totalDescuento: acc.totalDescuento + item.descuento,
      total: acc.total + item.total,
    }),
    { subTotal: 0, totalIGV: 0, totalDescuento: 0, total: 0 }
  );
}

export function formatCurrency(amount: number, symbol: string = 'S/'): string {
  return `${symbol} ${amount.toFixed(2)}`;
}
